export default __webpack_public_path__ + "static/media/legal-entities.61dde8fe.svg";